import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}
interface QuerySistarBanc {
  oidLiquidacion: number;
  oidBanco: number | undefined;
  documentoParaPago: number | null;
}

interface IResponse {
  ok: boolean;
  guidMensaje: string | number | null;
  tipoServicio: string | number | null;
  importe: number;
  idFactura: string | number | null;
}

export const pagoSistarBanc = async (
  query: QuerySistarBanc
): Promise<IResponse> => {
  try {
    const res = await apiClient.post<ApiResponse<IResponse>>(
      Endpoints.PagoSistarBanc,
      {
        oidLiquidacion: query.oidLiquidacion,
        oidBanco: query.oidBanco,
        documentoParaPago: `${query.documentoParaPago}`,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
